export const FLAGS = {
  THEME_EDITOR: (import.meta.env.FEATURE_THEME_EDITOR ?? '0') === '1',
} as const;
